module.exports = __webpack_public_path__ + "img/f-logo.4cf198c2.png";